module.exports = __webpack_public_path__ + "static/media/n-invite.d3e2e1b5.svg";